import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ProductPriceComponentDef } from '@df/ui/price/product-price.component.def';

@Component({
    selector: 'product-price',
    template: '<span [innerHTML]="getHtml()"></span>',
    standalone: true,
    imports: [CommonModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductPriceComponent extends ProductPriceComponentDef {}
